import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Paper, Typography, CircularProgress } from '@mui/material';
import { useAuth } from '../hooks/useAuth';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const { sessionStatus, isLoading, authError } = useAuth();

  useEffect(() => {
    if (isLoading) return;

    switch (sessionStatus) {
      case 'signed_out':
        navigate('/', { replace: true });
        break;
      case 'signed_in_no_profile':
        navigate('/onboarding', { replace: true });
        break;
      case 'signed_in_with_profile':
        navigate('/vote', { replace: true });
        break;
      default:
        navigate('/', { replace: true });
    }
  }, [isLoading, sessionStatus, navigate]);

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: 'grey.100',
        py: 6,
      }}
    >
      <Paper
        elevation={3}
        sx={{ p: 4, borderRadius: 2, textAlign: 'center', maxWidth: 450, width: '100%' }}
      >
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          {authError ? 'Something went wrong…' : 'Finishing sign‑in…'}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {authError ? authError.message : 'Please wait while we complete the process.'}
        </Typography>
        {!authError && (
          <Box sx={{ mt: 2 }}>
            <CircularProgress />
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default AuthCallback;
